import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.tsx';

export const AuthLayout = () => {
  const { status } = useAuth();

  if (status === 'loading') {
    return <></>;
  }

  if (status === 'authenticated') {
    return <Navigate to={'/'} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Outlet />
    </div>
  );
};
